/**
 * FBSBancaSUMAK
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ObtenerDetallePagoFacilitoME } from '../model/obtenerDetallePagoFacilitoME';
import { ObtenerDetallePagoFacilitoMS } from '../model/obtenerDetallePagoFacilitoMS';
import { ObtenerProductosPagoFacilitoME } from '../model/obtenerProductosPagoFacilitoME';
import { ObtenerProductosPagoFacilitoMS } from '../model/obtenerProductosPagoFacilitoMS';
import { ObtenerServiciosPagoFacilitoMS } from '../model/obtenerServiciosPagoFacilitoMS';
import { PagarProductoPagoFacilitoME } from '../model/pagarProductoPagoFacilitoME';
import { PagarProductoPagoFacilitoMS } from '../model/pagarProductoPagoFacilitoMS';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class PagoFacilitoService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiV10PagoFacilitoObtenerDetallePost(body?: ObtenerDetallePagoFacilitoME, observe?: 'body', reportProgress?: boolean): Observable<ObtenerDetallePagoFacilitoMS>;
    public apiV10PagoFacilitoObtenerDetallePost(body?: ObtenerDetallePagoFacilitoME, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ObtenerDetallePagoFacilitoMS>>;
    public apiV10PagoFacilitoObtenerDetallePost(body?: ObtenerDetallePagoFacilitoME, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ObtenerDetallePagoFacilitoMS>>;
    public apiV10PagoFacilitoObtenerDetallePost(body?: ObtenerDetallePagoFacilitoME, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ObtenerDetallePagoFacilitoMS>('post',`${this.basePath}/api/v1.0/PagoFacilito/ObtenerDetalle`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiV10PagoFacilitoObtenerProductosPost(body?: ObtenerProductosPagoFacilitoME, observe?: 'body', reportProgress?: boolean): Observable<ObtenerProductosPagoFacilitoMS>;
    public apiV10PagoFacilitoObtenerProductosPost(body?: ObtenerProductosPagoFacilitoME, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ObtenerProductosPagoFacilitoMS>>;
    public apiV10PagoFacilitoObtenerProductosPost(body?: ObtenerProductosPagoFacilitoME, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ObtenerProductosPagoFacilitoMS>>;
    public apiV10PagoFacilitoObtenerProductosPost(body?: ObtenerProductosPagoFacilitoME, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ObtenerProductosPagoFacilitoMS>('post',`${this.basePath}/api/v1.0/PagoFacilito/ObtenerProductos`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiV10PagoFacilitoObtenerServiciosGet(observe?: 'body', reportProgress?: boolean): Observable<ObtenerServiciosPagoFacilitoMS>;
    public apiV10PagoFacilitoObtenerServiciosGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ObtenerServiciosPagoFacilitoMS>>;
    public apiV10PagoFacilitoObtenerServiciosGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ObtenerServiciosPagoFacilitoMS>>;
    public apiV10PagoFacilitoObtenerServiciosGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ObtenerServiciosPagoFacilitoMS>('get',`${this.basePath}/api/v1.0/PagoFacilito/ObtenerServicios`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiV10PagoFacilitoPagarProductoPost(body?: PagarProductoPagoFacilitoME, observe?: 'body', reportProgress?: boolean): Observable<PagarProductoPagoFacilitoMS>;
    public apiV10PagoFacilitoPagarProductoPost(body?: PagarProductoPagoFacilitoME, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PagarProductoPagoFacilitoMS>>;
    public apiV10PagoFacilitoPagarProductoPost(body?: PagarProductoPagoFacilitoME, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PagarProductoPagoFacilitoMS>>;
    public apiV10PagoFacilitoPagarProductoPost(body?: PagarProductoPagoFacilitoME, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<PagarProductoPagoFacilitoMS>('post',`${this.basePath}/api/v1.0/PagoFacilito/PagarProducto`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
